class ShiftDetailRow extends React.Component {
  render () {
    return (
      <div className='row'>
        <div className='col-lg-12'>
          <div className='form-group col-sm-12 label-section'>
            <label>{this.props.label}</label>
            <div className='pull-right'>{this.props.value}</div>
          </div>
        </div>
      </div>
    )
  }
}

ShiftDetailRow.propTypes = {
  label: React.PropTypes.string
}
export default (ShiftDetailRow)



// WEBPACK FOOTER //
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailRow/ShiftDetailRow.js